// @ts-nocheck
import React from 'react';
import WorkflowPage from './WorkflowPageFactory';
import { CompensationForm } from '../workflow/CompanyApp';

export default function CompensationPage() {
  return (
    <WorkflowPage stepId="compensation">
      {({ data, setData, navigateTo }) => (
        <CompensationForm formData={data} setFormData={setData} setActiveTab={navigateTo} />
      )}
    </WorkflowPage>
  );
}
